import util from './util';

const IDS = {
    modal: 'aurion-context-select-modal', //  <div class="modal modal-fullscreen" id="aurion-context-select-modal" role="dialog"
    backButton: 'aurion-context-selector-search-result-back-button',
    loadMoreButtonContainer: 'aurion-context-selector-search-result-toolbar-next-page',
    loadMoreButton: 'aurion-context-selector-search-result-button-next-page',
    resultsContainer: 'aurion-context-selector-search-results',
    searchTextField: 'aurion-context-selector-input',
    searchTextFieldButton: 'aurion-context-selector-input-group-search-button',
    includeNonEmpCheckbox: 'aurion-context-selector-input-include-non-employees',
};
const isPastEmployees = window.location.pathname.includes('/past-employees');

class SectionTitle {
    build(data) {
        if (data.includes('Signed') || data.includes('viewing')) {
            return null;
        }
        return $.parseHTML(`<h6 class="text-muted my-3 d-none">${data}</h6>`);
    }
}

class BasicCell {
    build(data) {
        return $.parseHTML(
            `<h6 class="empty-message table-no-results text-center my-3"><em>${data}</em></h6>`,
        );
    }
}

class ContextSelectorCell {
    constructor() {
        this.JOB_TITLE = 1;
        this.ORG_UNIT = 2;
        this.LOCATION = 3;
        this.ALL = 4;
    }

    build(data) {
        const viewCell = this.buildSelectorCell(data);
        const drillCell = (0 < data.count && this.buildDrillCell(data)) || '';
        const clone = $.parseHTML(this.wrapCells(drillCell, viewCell));

        if (data.active) {
            // Highlight the currently selected context (if it's not a self)
            $(clone[0]).addClass('active active-warning');
        }

        return clone;
    }

    buildJobTitle(data, visibleId) {
        if (data.jobTitle && [this.JOB_TITLE, this.ALL].includes(data.headingFormat)) {
            return `<small class="aurion-context-selector-search-results-item-job-title">${data.jobTitle}</small>${visibleId ? `<small class="empId"> ${visibleId}</small><br>` : ''}`;
        }

        return '';
    }

    buildUnit(data) {
        if (data.unit && [this.ORG_UNIT, this.ALL].includes(data.headingFormat)) {
            return `<small class="aurion-context-selector-search-results-item-unit">${data.unit}</small><br>`;
        }

        return '';
    }

    buildLocation(data) {
        if (data.location && [this.LOCATION, this.ALL].includes(data.headingFormat)) {
            return `<small class="aurion-context-selector-search-results-item-location">${data.location}</small><br>`;
        }

        return '';
    }

    buildSelectorCell(data) {
        const url =
            (data.terminated || !data.nonEmployee ? data.code : data.wami) +
            (data.nonEmployee ? '?nonemployee=true' : '');

        const pillTag = data.nonEmployee
            ? '<span class="badge badge-pill nonEmp-badge">Non-employee</span>'
            : '';

        const idBadgeTag = data.nonEmployee ? '' : '<i class="fa-light fa-id-badge"></i>';

        const visibleId = (!data.hideEmpNo && (data.nonEmployee ? data.wami : data.empno)) || '';

        let letters = '';

        if (data.displayName && data.displayName.includes(' ')) {
            const findSecondLetter = data.displayName.indexOf(' ') + 1;
            if (data.displayName.includes(',')) {
                letters = data.displayName.charAt(findSecondLetter) + data.displayName.charAt(0);
            } else {
                letters = data.displayName.charAt(0) + data.displayName.charAt(findSecondLetter);
            }
        }

        const selectorContent = `
        <div id="profile" class="col emp-profile">
          <span id="first-letter" class="first-letter">${letters}</span>
          <div class="col emp-name flex-grow-1 align-items-center">
            <strong class="aurion-context-selector-search-results-item-display-name">${data.displayName}</strong>
            ${visibleId ? `<br><small class="empId">${visibleId}</small>` : ''}
          </div>
            ${idBadgeTag}
          <div class="col emp-details">
            ${pillTag}
            ${this.buildJobTitle(data, visibleId)}
            ${this.buildUnit(data)}
            ${this.buildLocation(data)}
          </div>
        </div>`;

        return data.code
            ? `<a href="" class="row d-flex w-100 list-group-item-link item-link text-decoration-none w-100"
                  data-empno="${data.code}"
                  data-url="${isPastEmployees ? 'past-employees/' : ''}api/context/select/${url}">${selectorContent}</a>`
            : `<div class="row d-flex w-100 list-group-item-link text-decoration-none disabled">${selectorContent}</div>`;
    }

    buildDrillCell(data) {
        return `<a href="" class="list-group-item-more"
            data-display-name="${data.displayName}"
            data-expand-id="${data.expandLink}">
          <span class="badge d-none d-sm-block float-end">${data.count}</span>
        </a>`;
    }

    wrapCells(selectorLink, detailLink) {
        return `<li class="list-group-item list-group-item-split">
            ${detailLink}
            ${selectorLink}
        </li>`;
    }
}

class CandidateSiteSelectorCell {
    build(data) {
        const template = `<a
                href="#"
                class="list-group-item"
                data-empno="${data.code}"
                data-url="api/context/select/${data.code}">${data.displayName}</a>`;

        return $.parseHTML(template);
    }
}

class CellFactory {
    constructor(document) {
        this.document = document;
    }

    create(type, data) {
        let cell;

        if (type === 'ContextSelectorCell') {
            cell = new ContextSelectorCell();
        } else if (type === 'CandidateSiteSelectorCell') {
            cell = new CandidateSiteSelectorCell();
        } else {
            cell = new BasicCell();
        }

        const cellElement = cell.build(data);
        cellElement.forEach((el) => {
            el.cellData = data;
        });

        return cellElement;
    }
}

/**
 * Notes:
 *
 *  * Drilling down on reports tree does not support "Load more".
 *
 */
class ContextSelector extends HTMLElement {
    //
    // --- Main entry points ---
    //

    constructor() {
        super();

        const getIfHas = (id) => (this.hasAttribute(id) && this.getAttribute(id)) || '';

        this.factory = new CellFactory(document);
        this.queries = [];
        this.history = []; // A stack of server results when drilling into reports tree
        this.selected = []; // A stack of "who was selected" objects (from the server results)
        this.shadow = this;
        this.cell = getIfHas('cell');
        this.endpoint = isPastEmployees ? 'past-employees/search/context' : getIfHas('endpoint');
        this.icon = getIfHas('icon');
        this.placeholder = getIfHas('placeholder');
        this.hideSearchInput = this.hasAttribute('readonly');
        this.canSearchNonEmployee = getIfHas('cansearchnonemployee');
    }

    connectedCallback() {
        // create view
        const $this = $(this);

        if (!this.hideSearchInput) {
            $this.append(this.createSearchInput());
            this.addSearchInputEventListeners();
        }

        $this.append(this.createSearchList());

        // Load the initial screen state

        this.results = this.shadow.querySelector(`[id=${IDS.resultsContainer}]`);
        this.search();
    }

    /**
     * Load new results from server.
     *
     * @param {string} query
     *      State of the search field (or expand ID if drilling down in the reports tree).
     *
     * @param {boolean} includeStaff
     *      True if drilling down on a position (reports tree).
     *
     * @param {boolean} includeNonEmps
     *      True to include WAMI (not empno ie: people and terminated) results.
     */
    search(query = '', includeStaff = false, includeNonEmps = false) {
        this.query = query;

        if (!includeStaff) {
            while (this.history.length) {
                this.history.pop();
                this.queries.pop();
                this.selected.pop();
            }

            this.hideBackButton();
        }

        this.clear();
        const cell = this.factory.create('BasicCell', 'Loading...');
        const container = document.getElementById(IDS.resultsContainer);

        cell.forEach((item) => {
            container.appendChild(item);
        });

        let url = `${this.endpoint}/${query}`;

        if (includeStaff) {
            url += '?staff=1'; // User clicked on the drill down button
        } else if (includeNonEmps) {
            url += '?includeNonEmps=true'; // else use search string, and checkbox is checked.
        }

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                const searchInput = this.shadow.querySelector(`[id=${IDS.searchTextField}]`);
                const searchButton = this.shadow.querySelector(`[id=${IDS.searchTextFieldButton}]`);
                if (this.query === query) {
                    this.clear();
                    this.handleData(data);
                    this.addEventListeners();
                }
                searchInput.disabled = false;
                searchButton.disabled = false;
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }

    /**
     * Process results object from the server.
     *
     * @param {Object} data The results object from ContextSearchController.
     */
    handleData(data) {
        this.data = data.slice();
        const page = data.pop();
        const sections = this.data.filter((section) => section.items && 0 < section.items.length);

        sections.forEach((section) => {
            let id;

            if (section.topModel) {
                if (document.getElementsByClassName('signed').length === 0) {
                    id = `${section.sectionTitle.replaceAll(' ', '-')}`;
                    this.topModelCell(section, section.id, id);
                } else if (document.getElementsByClassName('viewing').length === 0) {
                    id = `${section.sectionTitle.replaceAll(' ', '-')}`;
                    this.topModelCell(section, section.id, id);
                }
            } else {
                if (section.sectionTitle) {
                    id = `${section.sectionTitle.replaceAll(' ', '-')}`;
                    this.addCellToList(`<div id="${id}"></div>`);
                    this.addCellToList(new SectionTitle().build(section.sectionTitle), id);
                }

                section.items.forEach((user) => {
                    this.addCellToList(this.factory.create(this.cell, user), id);
                });
            }
        });

        const paging = this.results.querySelector(`[id=${IDS.loadMoreButtonContainer}]`);
        if (paging) paging.parentElement.removeChild(paging);

        if (page.remaining) {
            this.showLoadMoreButton();
        } else {
            this.hideLoadMoreButton();
        }

        const hasResults = sections.length;

        if (!hasResults) {
            const cell = this.factory.create('BasicCell', 'None found...');
            this.addCellToList(cell);
        }
    }

    //
    // --- Event handlers ---
    //

    addSearchInputEventListeners() {
        const searchInput = this.shadow.querySelector(`[id=${IDS.searchTextField}]`);
        const searchButton = this.shadow.querySelector(`[id=${IDS.searchTextFieldButton}]`);
        const checkbox = this.shadow.querySelector(`[id=${IDS.includeNonEmpCheckbox}]`);

        searchInput.addEventListener('keyup', (event) => {
            if (event.keyCode === 13 || event.key === 'Enter') {
                searchInput.disabled = true;
                searchButton.disabled = true;
                const query = searchInput.value;

                if (this.searchInputTimeout) clearTimeout(this.searchInputTimeout);
                this.search(query, false, this.includeNonEmps());
            }
        });

        searchButton.addEventListener('click', () => {
            searchInput.disabled = true;
            searchButton.disabled = true;
            if (this.searchInputTimeout) clearTimeout(this.searchInputTimeout);
            this.search(searchInput.value, false, this.includeNonEmps());
        });

        if (checkbox) {
            checkbox.addEventListener('change', () => {
                searchInput.disabled = true;
                searchButton.disabled = true;
                const attribs = {
                    true: {
                        title: this.nonemployeeSearchPlaceholder,
                        placeholder: `${this.nonemployeeSearchPlaceholder}...`,
                    },
                    false: {
                        title: this.normalPlaceholder,
                        placeholder: `${this.normalPlaceholder}...`,
                    },
                }[checkbox.checked];

                if (this.searchInputTimeout) clearTimeout(this.searchInputTimeout);

                searchInput.setAttribute('title', attribs.title);
                searchInput.setAttribute('placeholder', attribs.placeholder);

                this.search(searchInput.value, false, this.includeNonEmps());
            });
        }
    }

    addEventListeners() {
        const button = this.shadow.querySelector(`[id=${IDS.loadMoreButtonContainer}]`);
        if (button) button.addEventListener('click', this);

        Array.from(this.shadow.querySelectorAll('a')).forEach((a) =>
            a.addEventListener('click', this),
        );

        // TODO: Find a better way for this addEventListener
        Array.from(document.querySelectorAll('a.item-link')).forEach((a) =>
            a.addEventListener('click', this),
        );
    }

    /**
     * @override EventListener.handleEvent()
     */
    handleEvent(event) {
        if (event) event.preventDefault();
        const a = event.currentTarget;

        if (a.id === IDS.backButton) {
            this.handleBackButtonClicked(event);
        } else if (a.id === IDS.loadMoreButtonContainer) {
            this.handleLoadMoreClicked(event);
        } else if (a.getAttribute('data-expand-id')) {
            this.handleDetailViewClicked(event);
        } else if (a.getAttribute('data-url')) {
            this.handleSelected(event);
        }
    }

    /**
     * Change context.
     */
    handleSelected(event) {
        this.dispatchEvent('appShowLoadingIndicator');
        const a = event.currentTarget;
        const url = a.getAttribute('data-url'); // eg: api/context/select/9002?nonemployee=true
        const resetUrl = document.getElementById('contextResetUrl') || window.contextResetUrl;

        window.ajax({
            method: 'get',
            url,
            documentType: 'json',
            success: (data) => {
                if (
                    data.empno === a.getAttribute('data-empno') ||
                    data.wami === a.getAttribute('data-wami')
                ) {
                    if (typeof resetUrl === 'string') {
                        window.location = util.urlBase() + resetUrl;
                    } else if (typeof resetUrl === 'object') {
                        window.location = util.urlBase() + resetUrl.value;
                    } else {
                        this.dispatchEvent('aurion-app-reload');
                    }
                }
            },
            failure: () => {
                this.dispatchEvent('appHideLoadingIndicator');
            },
        });
    }

    /**
     * Drill down on reports tree item
     */
    handleDetailViewClicked(event) {
        const a = event.currentTarget;
        const cellData = this.findCellData(a);
        const expandLink = a.getAttribute('data-expand-id');

        const backButtonLabel = cellData.backButtonLabel || cellData.displayName;

        this.history.push(this.data); // Save the current state data
        this.selected.push(cellData); // Who was just clicked (for the back button)
        this.queries.push(this.query); // this.query: used to determine if response is stale.
        this.showBackButton(backButtonLabel);
        return this.search(expandLink, true);
    }

    /**
     * Undo drill down on reports tree item
     */
    handleBackButtonClicked() {
        this.query = this.queries.pop();
        this.selected.pop(); // we don't care about who was selected
        this.data = this.history.pop();
        const cell = this.selected.slice(-1).pop(); // The parent of who was selected

        if (this.history.length) {
            const backButtonLabel = cell && (cell.backButtonLabel || cell.displayName);
            this.showBackButton(backButtonLabel);
        } else {
            this.hideBackButton();
        }

        this.clear();
        this.handleData(this.data);
        this.addEventListeners();
    }

    handleLoadMoreClicked() {
        this.page += 1;

        let url = `${this.endpoint}/${this.query}?page=${this.page}`;
        if (this.includeNonEmps()) url += '&includeNonEmps=true';

        $.get(url, (data) => {
            // FIXME: There's no error handling here.
            this.handleData(data);
            this.addEventListeners();
        });
    }

    //
    // --- Utility methods ---
    //

    addCellToList(cell, id = IDS.resultsContainer) {
        $(`#${id}`).append(cell);
    }

    topModelCell(section, elementId, id = IDS.resultsContainer) {
        const newId = document.getElementById(elementId);
        const div = document.createElement('div');
        div.setAttribute('id', id);
        div.setAttribute('class', elementId);
        newId.appendChild(div);
        this.addCellToList(this.factory.create(this.cell, section.items[0]), id);

        document.getElementById('first-letter').remove();
        const img = document.createElement('img');
        const profile = document.getElementById('profile');
        img.setAttribute('src', section.items[0].photo);
        img.setAttribute('class', 'rounded-circle staff-photo');
        profile.insertBefore(img, profile.firstChild);
    }

    /**
     * Reset UI and data - ready for a new set of results
     */
    clear() {
        this.hideLoadMoreButton();
        this.page = 1;
        while (this.results.firstChild) this.results.removeChild(this.results.firstChild);
    }

    createSearchInput() {
        this.normalPlaceholder = 'Enter name or employee number';
        this.nonemployeeSearchPlaceholder = 'Enter name or person number';
        let template = `
            <div class="input-group input-group-lg my-4">
                <input type="text"
                    id="${IDS.searchTextField}"
                    class="form-control form-control-lg"
                    placeholder="${this.normalPlaceholder}..."
                    title="${this.normalPlaceholder}">
                    <button
                        id="${IDS.searchTextFieldButton}"
                        class="fa-light fa-magnifying-glass form-input-button rounded-end"
                        tabindex="-1"
                    >
                    </button>
            </div>`;

        if (this.canSearchNonEmployee === 'true') {
            template += `
            <div class="mb-3 form-check ms-2">
                <input class="form-check-input" type="checkbox" value="" id="${IDS.includeNonEmpCheckbox}">
                <label class="form-check-label" for="${IDS.includeNonEmpCheckbox}">
                    Include non-employees
                </label>
            </div>`;
        }

        return $.parseHTML(template);
    }

    createSearchList() {
        const template = `
            <a id="${IDS.backButton}"
                href="#" class="list-group-item list-group-item-back mt-3 d-none">
                <strong></strong>
                <span class="visually-hidden">Back</span>
            </a>
            <div id="${IDS.resultsContainer}"
                class="list-group list-group-menu">
            </div>
            <div id="${IDS.loadMoreButtonContainer}" class="↔️ responsive d-flex flex-column flex-sm-row my-3 d-none">
                <button
                    id="${IDS.loadMoreButton}"
                    type="button"
                    class="btn btn-secondary text-center w-100 fs-6"
                    data-loading-text="Loading..."
                    data-error-text="Oops... try again!"
                    data-completed-text="Load more">Load more</button>
            </div>`;

        return $.parseHTML(template);
    }

    showBackButton(backButtonLabel) {
        const button = this.shadow.querySelector(`[id=${IDS.backButton}]`);
        button.innerHTML = `<strong>${backButtonLabel || 'Back'}</strong>`;
        util.showElement(button);
    }

    hideBackButton() {
        const button = this.shadow.querySelector(`[id=${IDS.backButton}]`);
        util.showElement(button, false);
    }

    showLoadMoreButton() {
        const button = this.shadow.querySelector(`[id=${IDS.loadMoreButtonContainer}]`);
        button.classList.remove('d-none');
    }

    hideLoadMoreButton() {
        const button = this.shadow.querySelector(`[id=${IDS.loadMoreButtonContainer}]`);
        button.classList.add('d-none');
    }

    findCellData(element) {
        while (element) {
            if (element.cellData) return element.cellData;
            element = element.parentNode;
        }
    }

    dispatchEvent(type) {
        const e = document.createEvent('CustomEvent');
        e.initCustomEvent(type, true, null, { type: 'list' });
        document.dispatchEvent(e);
    }

    // Check the status of checkbox
    includeNonEmps() {
        const checkbox = this.shadow.querySelector(`[id=${IDS.includeNonEmpCheckbox}]`);
        if (checkbox) return checkbox.checked;
        return null;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('context-search-bar')) {
        // Defined in headSearchBar.handlebars
        customElements.define('aurion-context-select', ContextSelector);
    }
});
